import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import ManagementData from "@jsons/management.json"
import ManagementTeamSection from "@pages/Management/ManagementTeam/ManagementTeamSection"
import TitleSection from "@pages/Management/TitleSection"
import React from "react"

// const ManagementTeamSection = React.lazy(
// 	async () =>
// 		await import(
// 			/* webpackChunkName: "ma-ManagementTeamSection" */ "@pages/Management/ManagementTeam/ManagementTeamSection"
// 		),
// )

type Props = {}

const management = (props: Props): JSX.Element => {
	const AdvancedSideAsset = getTranslatedPageData(ManagementData, true, true)
	const list = getValueOrThrow(AdvancedSideAsset.AdvancedSideAsset)

	return (
		<>
			<HeadMeta meta={AdvancedSideAsset.metaData} />

			<FullWidthHeader
				data={getValueOrThrow(list?.[2].mainContent)[0]}
				position={"center"}
				size={"L"}
				withOverlay
			/>
			<TitleSection
				data={getValueOrThrow(list[0]?.mainContent?.[0])}
				direction={"left"}
				shortDesc={500}
				withAutoSizing
			/>

			<ManagementTeamSection
				data={getValueOrThrow(list[1]?.mainContent)}
			/>
		</>
	)
}

export default management
